import getObjectsViewLabel from "@utils/getObjectsViewLabel"

import { TabItem } from "@atoms"

import { TabStack } from "@molecules"

import useViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider.context"

import { OBJECTS_VIEW_ICONS } from "@constants/objectsViewIcons"

import { ViewSelectorProps } from "./ViewSelector.types"

export default function ViewSelector(props: ViewSelectorProps) {
    const { viewTypes } = props

    const { activeViewType, setActiveViewType } = useViewTypesProvider()

    const tabStackTabs = viewTypes.map((viewType) => (
        <TabItem
            key={viewType}
            icon={OBJECTS_VIEW_ICONS[viewType].inactive}
            iconActive={OBJECTS_VIEW_ICONS[viewType].active}
            isSelected={activeViewType === viewType}
            onClick={() => setActiveViewType(viewType)}
            noDebounce={true}
            orientation="vertical"
        >
            {getObjectsViewLabel(viewType)}
        </TabItem>
    ))

    return (
        <TabStack variant="contained" size="lg">
            {tabStackTabs}
        </TabStack>
    )
}
